// extracted by mini-css-extract-plugin
export default {"info":"WelcomeBack_info__lQ1Z3","actions":"WelcomeBack_actions__pLbvA"};